module.exports = __webpack_public_path__ + "static/media/Circles-pana.ba53ab1e.svg";